/**
 * Upper bounds on how long the copy flows wait for an answer. The fetch client
 * in `src/lib/axiosInstance.ts` has no default timeout, so without these a slow
 * BFF or E1 hop leaves a modal spinner up indefinitely. Propagate and bulk
 * export legitimately run long and are deliberately left unbounded.
 */
export const COPY_APPROVAL_REQUEST_TIMEOUT_MS = 30_000
export const COMMUNITY_LOOKUP_TIMEOUT_MS = 30_000
export const BULK_COPY_TIMEOUT_MS = 120_000

export const REQUEST_TIMEOUT_MESSAGE =
  'Plan Library did not get a response in time. Please try again.'

/** Status code a timed-out request settles with, so callers can tell it apart. */
export const REQUEST_TIMEOUT_STATUS_CODE = 408
/** Status code the admin API answers when an approval record already exists. */
export const CONFLICT_STATUS_CODE = 409
